import * as angular from 'angular';

export interface SelectionEvent<T> {
    newSelection: T[];
    previousSelection: T[];
}

export default class Selection<T> {
    private selected: T[] = [];
    constructor(private readonly onSelectionChange?: (event: SelectionEvent<T>) => void) {
    }

    size() {
        return this.selected.length;
    }

    getSelected() {
        return this.selected;
    }

    isEmpty() {
        return this.selected.length === 0;
    }

    isSelected(identifier: T) {
        return this.selected.indexOf(identifier) !== -1;
    }

    /**
     *  set add = true to add the item to the selection.
     *  false or undefined will replace the selction with the item
     */
    toggleSelected(identifier: T, add: boolean) {
        if (add) {
            if (this.isSelected(identifier)) {
                this.dounselect(identifier);
            } else {
                this.doselect(identifier);
            }
        } else {
            this.select(identifier, true);
        }
    }

    select(identifier: T | T[], replace: boolean) {
        if (Array.isArray(identifier)) {
            identifier.forEach(function(value: T) {
                this.doselect(value, replace);
            }.bind(this));
        } else {
            this.doselect(identifier, replace);
        }
    }

    // selects identifiers present in both this.selected and identifierList
    intersect(identifiers: T[]){
        let setB = new Set(identifiers);
        //let intersection = new Set(this.selected.filter(x => setB.has(x)));
        let intersection = this.selected.filter(x => setB.has(x));
        this.clear();
        this.select(intersection, false);

    }

    unselect(identifier: T | T[]) {
        if (Array.isArray(identifier)) {
            identifier.forEach(function(value: T) {
                this.dounselect(value);
            }.bind(this));
        } else {
            this.dounselect(identifier);
        }
    }

    clear() {
        this.select(undefined, true);
    }

    doselect(identifier: T, replace = false) {
        const previouslySelected = this.selected.slice(0);
        if (replace) {
            this.selected.length = 0;
        }
        if (identifier && this.selected.indexOf(identifier) == -1) {
            this.selected.push(identifier);
        }
        if (!angular.equals(this.selected, previouslySelected)) {
            this.callOnSelectionChange(this.selected, previouslySelected);
        }
    }

    dounselect(identifier: T) {
        const idx = this.selected.indexOf(identifier);
        if (idx !== -1) {
            const previouslySelected = this.selected.slice(0);
            this.selected.splice(idx, 1);
            this.callOnSelectionChange(this.selected, previouslySelected);
        }
    }

    // Calls onSelectionChange if it is a function or an array of functions
    callOnSelectionChange(selected: T[], previouslySelected: T[]) {
        if (this.onSelectionChange) {
            if (Array.isArray(this.onSelectionChange)) {
                this.onSelectionChange.forEach(function(f) {
                    f({
                        newSelection: selected,
                        previousSelection: previouslySelected
                    });
                });
            } else {
                this.onSelectionChange({
                    newSelection: selected,
                    previousSelection: previouslySelected
                });
            }

        }
    }
}
